module.exports = __webpack_public_path__ + "assets/images_base/facebook-logo-white.svg?v=6448c65a";